// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><g fill=\"%236b6b6b\" fill-rule=\"evenodd\"><path d=\"M20 20h-4v-4h4v4zm-6-10h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm6 0h-4v4h4v-4zm-6-6h-4v4h4v-4zm16-8v22h-24v-22h3v1c0 1.103.897 2 2 2s2-.897 2-2v-1h10v1c0 1.103.897 2 2 2s2-.897 2-2v-1h3zm-2 6h-20v14h20v-14zm-2-7c0-.552-.447-1-1-1s-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2zm-14 2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-.552.447-1 1-1s1 .448 1 1v2z\"/></g></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** CONTAINER STYLES **/

.DateRangePickerInput {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-width: 0px;
  background-color: transparent;
}

.DateRangePicker_picker {
  margin-top: -0.25rem;
}

/** INPUT DIV STYLES **/

.DateInput {
  background: transparent;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 0%;
          flex: 1 1 0%;
}

/** INPUT FIELD COMMON STYLES **/

.DateInput_input {
  /* used data:image as background-image because svg import with relative url didn't work */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-size: 14px;
  background-position: 10px center;
  background-repeat: no-repeat;
  margin-top: 0.5rem;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0.25rem;
  border-top-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgba(9, 68, 179, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 0.75rem;
  padding-left: 2rem;
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  -webkit-box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
          box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, -webkit-box-shadow, -webkit-transform;
  -webkit-transition-duration: 300ms;
          transition-duration: 300ms;
  -webkit-animation-duration: 300ms;
          animation-duration: 300ms;
}

.DateInput_input:hover {
  --tw-border-opacity: 1;
  border-color: rgba(160, 174, 192, var(--tw-border-opacity));
}

.DateInput_input:focus {
  --tw-border-opacity: 1;
  border-color: rgba(160, 174, 192, var(--tw-border-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
}

/** FIRST INPUT STYLES **/

.DateInput:first-child .DateInput_input {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.DateInput:first-child .DateInput_input:hover,
.DateInput:first-child .DateInput_input:focus {
  position: relative;
  z-index: 10;
}

/** SECOND INPUT STYLES **/

.DateInput:last-child .DateInput_input {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  margin-left: -1px;
}

/** ARROW STYLES **/

.DateRangePickerInput_arrow {
  display: none;
}

/* SELECT MONTH PICKER */

.DateRangePicker_select {
  cursor: pointer;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(114, 111, 126, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 1.25rem;
  font-size: 0.8125rem;
  --tw-text-opacity: 1;
  color: rgba(31, 31, 39, var(--tw-text-opacity)); /* NEEDED FOR ARROW DOWN */
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position:
    calc(100% - 11px) 11px,
    calc(100% - 6px) calc(11px);
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
}

/* CALENDAR DAYS */

.CalendarDay {
  border-radius: 9999px;
  border-width: 0px;
}

.CalendarDay:hover,
.CalendarDay__selected,
.CalendarDay__selected:active,
.CalendarDay__selected:hover {
  border-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgba(9, 68, 179, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(9, 68, 179, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.CalendarDay__blocked_out_of_range:hover {
  cursor: not-allowed;
  border-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(114, 111, 126, var(--tw-text-opacity));
}

.CalendarDay__selected_span {
  border-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgba(90, 204, 230, var(--tw-bg-opacity));
}

/* MONTH NAVIGATION BUTTONS */

.DayPickerNavigation_button__horizontalDefault,
.DayPickerNavigation_button__horizontalDefault:hover {
  --tw-border-opacity: 1;
  border-color: rgba(114, 111, 126, var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgba(114, 111, 126, var(--tw-text-opacity));
  top: 24px;
  padding: 3px 9px;
}

.DayPickerNavigation_svg__horizontal {
  fill: currentColor;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/DateRange/DateRange.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGrB;EAAA,oBAAmC;EAAnC,oBAAmC;EAAnC,aAAmC;EAAnC,iBAAmC;EAAnC;AAAmC;;AAInC;EAAA;AAAY;;AAGd,uBAAuB;;AAEvB;EACE,uBAAuB;EACvB,oBAAyB;EAAzB,oBAAyB;EAAzB,aAAyB;EAAzB,WAAyB;EAAzB,mBAAyB;MAAzB,gBAAyB;UAAzB,YAAyB;AAC3B;;AAEA,gCAAgC;;AAEhC;EACE,yFAAyF;EACzF,yDAA8hB;;EAE9hB,qBAAqB;EACrB,gCAAgC;EAChC,4BAAmB;EAGnB,kBAAiO;EAAjO,WAAiO;EAAjO,eAAiO;EAAjO,wBAAiO;KAAjO,qBAAiO;UAAjO,gBAAiO;EAAjO,sBAAiO;EAAjO,qBAAiO;EAAjO,sBAAiO;EAAjO,uBAAiO;EAAjO,wBAAiO;EAAjO,mBAAiO;EAAjO,sBAAiO;EAAjO,wDAAiO;EAAjO,kBAAiO;EAAjO,qDAAiO;EAAjO,mBAAiO;EAAjO,sBAAiO;EAAjO,sBAAiO;EAAjO,kBAAiO;EAAjO,kBAAiO;EAAjO,gBAAiO;EAAjO,iBAAiO;EAAjO,oBAAiO;EAAjO,kDAAiO;EAAjO,4EAAiO;EAAjO,2FAAiO;EAAjO,0EAAiO;UAAjO,kEAAiO;EAAjO,+HAAiO;UAAjO,uHAAiO;EAAjO,gIAAiO;EAAjO,wHAAiO;EAAjO,wGAAiO;EAAjO,+IAAiO;EAAjO,kCAAiO;UAAjO,0BAAiO;EAAjO,iCAAiO;UAAjO,yBAAiO;AAFnO;;AAKE;EAAA,sBAAsB;EAAtB;AAAsB;;AAGtB;EAAA,sBAAmC;EAAnC,2DAAmC;EAAnC,8BAAmC;EAAnC;AAAmC;;AAErC,yBAAyB;;AAEvB;EAAA,4BAAqB;EAArB;AAAqB;;AAKrB;;EAAA,kBAAoB;EAApB;AAAoB;;AAGtB,0BAA0B;;AAExB;EAAA,2BAAqB;EAArB,8BAAqB;EACrB;AADqB;;AAGvB,mBAAmB;;AAEjB;EAAA;AAAa;;AAGf,wBAAwB;;AAEtB;EAAA,eAA+H;EAA/H,wBAA+H;KAA/H,qBAA+H;UAA/H,gBAA+H;EAA/H,sBAA+H;EAA/H,iBAA+H;EAA/H,sBAA+H;EAA/H,2DAA+H;EAA/H,kBAA+H;EAA/H,2DAA+H;EAA/H,oBAA+H;EAA/H,uBAA+H;EAA/H,oBAA+H;EAA/H,sBAA+H;EAA/H,oBAA+H;EAA/H,oBAA+H;EAA/H,+CAA+H,EAAE,0BAA0B;EAC3J;sDACoD;EACpD;;+BAE6B;EAC7B;;WAES;EACT;AAT+H;;AAWjI,kBAAkB;;AAEhB;EAAA,qBAA4B;EAA5B;AAA4B;;AAO5B;;;;EAAA,iBAA8D;EAA9D,sBAA8D;EAA9D,wDAA8D;EAA9D,kBAA8D;EAA9D,wDAA8D;EAA9D,oBAA8D;EAA9D;AAA8D;;AAI9D;EAAA,mBAA4D;EAA5D,iBAA4D;EAA5D,kBAA4D;EAA5D,2DAA4D;EAA5D,oBAA4D;EAA5D;AAA4D;;AAI5D;EAAA,iBAAgC;EAAhC,kBAAgC;EAAhC;AAAgC;;AAGlC,6BAA6B;;AAG3B;;EAAA,sBAA0C;EAA1C,2DAA0C;EAA1C,oBAA0C;EAA1C,kDAA0C;EAC1C,SAAS;EACT;AAF0C;;AAK1C;EAAA;AAAmB","sourcesContent":["/** CONTAINER STYLES **/\n\n.DateRangePickerInput {\n  @apply flex border-0 bg-transparent;\n}\n\n.DateRangePicker_picker {\n  @apply -mt-1;\n}\n\n/** INPUT DIV STYLES **/\n\n.DateInput {\n  background: transparent;\n  @apply flex w-auto flex-1;\n}\n\n/** INPUT FIELD COMMON STYLES **/\n\n.DateInput_input {\n  /* used data:image as background-image because svg import with relative url didn't work */\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><g fill=\"%236b6b6b\" fill-rule=\"evenodd\"><path d=\"M20 20h-4v-4h4v4zm-6-10h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm6 0h-4v4h4v-4zm-6-6h-4v4h4v-4zm16-8v22h-24v-22h3v1c0 1.103.897 2 2 2s2-.897 2-2v-1h10v1c0 1.103.897 2 2 2s2-.897 2-2v-1h3zm-2 6h-20v14h20v-14zm-2-7c0-.552-.447-1-1-1s-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2zm-14 2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-.552.447-1 1-1s1 .448 1 1v2z\"/></g></svg>');\n\n  background-size: 14px;\n  background-position: 10px center;\n  @apply bg-no-repeat;\n}\n.DateInput_input {\n  @apply border-primary-main mt-2 w-full cursor-pointer appearance-none rounded border-t border-l border-r border-b border-solid bg-black py-2 px-3 pl-8 text-sm font-light leading-tight text-white shadow transition duration-300;\n}\n.DateInput_input:hover {\n  @apply border-gray-500;\n}\n.DateInput_input:focus {\n  @apply border-gray-500 outline-none;\n}\n/** FIRST INPUT STYLES **/\n.DateInput:first-child .DateInput_input {\n  @apply rounded-r-none;\n}\n\n.DateInput:first-child .DateInput_input:hover,\n.DateInput:first-child .DateInput_input:focus {\n  @apply relative z-10;\n}\n\n/** SECOND INPUT STYLES **/\n.DateInput:last-child .DateInput_input {\n  @apply rounded-l-none;\n  margin-left: -1px;\n}\n/** ARROW STYLES **/\n.DateRangePickerInput_arrow {\n  @apply hidden;\n}\n\n/* SELECT MONTH PICKER */\n.DateRangePicker_select {\n  @apply text-secondary-active border-common-dark cursor-pointer appearance-none rounded border bg-white py-1 pl-2 pr-5 text-base; /* NEEDED FOR ARROW DOWN */\n  background-image: linear-gradient(45deg, transparent 50%, gray 50%),\n    linear-gradient(135deg, gray 50%, transparent 50%);\n  background-position:\n    calc(100% - 11px) 11px,\n    calc(100% - 6px) calc(11px);\n  background-size:\n    5px 5px,\n    5px 5px;\n  background-repeat: no-repeat;\n}\n/* CALENDAR DAYS */\n.CalendarDay {\n  @apply rounded-full border-0;\n}\n\n.CalendarDay:hover,\n.CalendarDay__selected,\n.CalendarDay__selected:active,\n.CalendarDay__selected:hover {\n  @apply bg-primary-main border-primary-main border-0 text-white;\n}\n\n.CalendarDay__blocked_out_of_range:hover {\n  @apply text-common-dark cursor-not-allowed border-0 bg-white;\n}\n\n.CalendarDay__selected_span {\n  @apply bg-primary-light border-0;\n}\n\n/* MONTH NAVIGATION BUTTONS */\n.DayPickerNavigation_button__horizontalDefault,\n.DayPickerNavigation_button__horizontalDefault:hover {\n  @apply border-common-dark text-common-dark;\n  top: 24px;\n  padding: 3px 9px;\n}\n.DayPickerNavigation_svg__horizontal {\n  @apply fill-current;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
